import { SanitizeHTML } from '@/components/Elements/SanitizedHTML/SanitizedHTML';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { MegaphoneIcon } from '@heroicons/react/24/solid';
import { useMessageOfTheDay } from '../hooks/useMessageOfTheDay';

export const MessageOfTheDay = () => {
  const { isUnseen, message, dismiss } = useMessageOfTheDay();

  if (!message || !isUnseen) return <></>;

  return (
    <div className="rounded p-4 border bg-blue-50 border-blue-200 dark:bg-blue-900/50 dark:border-blue-900">
      <div className="flex">
        <div className="shrink-0">
          <MegaphoneIcon className="h-5 w-5 text-blue-400 dark:text-blue-500" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-zinc-800 dark:text-zinc-200">{message.title}</h3>
          <div className="mt-2 text-sm text-zinc-700 dark:text-zinc-300">
            <SanitizeHTML html={message.content} />
          </div>
        </div>
        <div className="ml-auto pl-3">
          <div className="-mx-1.5 -my-1.5">
            <button
              type="button"
              onClick={() => dismiss(message.id)}
              className="inline-flex rounded-md bg-blue-50 dark:bg-blue-900/20 p-1.5 text-blue-500 hover:bg-blue-100 dark:hover:bg-blue-800 focus:outline-hidden focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 focus:ring-offset-blue-50"
            >
              <span className="sr-only">Dismiss</span>
              <XMarkIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
